import React from "react";
import { FeeFormulaTab } from "./FeeFormula";
import { RulesTab } from "./Rules";

export const tabs = [
  { label: 'Fee', component: <FeeFormulaTab /> },
  { label: 'Rules', component: <RulesTab /> },
]
